import React, { useState } from 'react'

const Entry = ({ title, description, image, href, slug, next }) => {
  const [mouseover, setMouseover] = useState(false)

  return (
    <div
      id={slug}
      style={{
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 2,
        background: 'black',
        height: '100vh',
        width: '100vw'
      }}
    >
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        style={{ height: '75%', width: '100%', opacity: mouseover ? 0.85 : 1 }}
      >
        <div
          onMouseEnter={() => setMouseover(true)}
          onMouseLeave={() => setMouseover(false)}
          style={{
            height: '100%',
            width: '100%',
            backgroundImage: `url(${image})`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center center',
            backgroundSize: 'cover',
            transition: 'opacity 250ms ease-in',
            cursor: 'pointer'
          }}
        />
      </a>
      <i
        style={{
          position: 'absolute',
          top: 'calc(75% / 2)',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          fontSize: 50,
          color: 'white',
          opacity: mouseover ? 1 : 0,
          transition: 'opacity 250ms ease-in',
          zIndex: 3,
          pointerEvents: 'none'
        }}
        className="fas fa-play"
      />

      <div
        style={{
          height: '25%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-around',
          alignItems: 'center',
          color: 'white'
        }}
      >
        <div style={{ textAlign: 'center' }}>
          <div style={{ textTransform: 'uppercase', fontWeight: 700, lineHeight: 2 }}>{title}</div>
          <div style={{ lineHeight: 2 }}>{description}</div>
        </div>
        {next ? (
          <a href={`#${next.slug}`} style={{ lineHeight: 2 }}>
            <i className="fas fa-angle-down" style={{ color: 'white', fontSize: 32 }} />
          </a>
        ) : (
            <footer style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', lineHeight: 1.33, fontWeight: 300, fontSize: 16 }}>
              <div>
                taylorblack25(at)gmail(dot).com
                </div>
              <div>
                maximillianeinstein(at)gmail(dot).com
                </div>
            </footer>
          )}
      </div>
    </div>
  )
}

export default Entry
